import { render, staticRenderFns } from "./DropdownList.vue?vue&type=template&id=870cf7b6&scoped=true&"
import script from "./DropdownList.vue?vue&type=script&lang=js&"
export * from "./DropdownList.vue?vue&type=script&lang=js&"
import style0 from "./DropdownList.vue?vue&type=style&index=0&id=870cf7b6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870cf7b6",
  null
  
)

export default component.exports